let timer;

export function startStompCheck(api) {
  api.stompCheck();
  timer = setInterval(api.stompCheck, 1000 * 60 * 5); // every five minutes
}

export function stopStompCheck() {
  clearInterval(timer);
}
